import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-pncl-menu-divider',
  templateUrl: './pncl-menu-divider.component.html',
  styleUrls: ['./pncl-menu-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ MatDividerModule ]
})
export class PnclMenuDividerComponent {
}
